import { render, staticRenderFns } from "./AddIndividual.vue?vue&type=template&id=507005f6&"
import script from "./AddIndividual.vue?vue&type=script&lang=js&"
export * from "./AddIndividual.vue?vue&type=script&lang=js&"
import style0 from "./AddIndividual.vue?vue&type=style&index=0&id=507005f6&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('507005f6')) {
      api.createRecord('507005f6', component.options)
    } else {
      api.reload('507005f6', component.options)
    }
    module.hot.accept("./AddIndividual.vue?vue&type=template&id=507005f6&", function () {
      api.rerender('507005f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sales/customers/Add/AddIndividual.vue"
export default component.exports